import styled from "@emotion/styled";
import { BaseFormLabel, baseFormLabelClasses, BaseFormLabelProps } from "@kaltura/mediaspace-shared-ui";
import { useContext } from "react";
import { ContentContext } from "../../ContentContext";

const StyledFormLabel = styled(BaseFormLabel)<{ variant: "body2" | "body2Highlight" }>(({ theme, variant }) => ({
    [`.${baseFormLabelClasses.label}`]: {
        color: theme.kaltura.palette.tone2,
        ...(
            variant === "body2Highlight" && {
                color: theme.kaltura.palette.tone1,
            }
        ),
    },
}));

/**
 * form label styled based on context
 * @param props
 */
export function SmartFormLabel(props: BaseFormLabelProps) {
    const contentContext = useContext(ContentContext) || { fullWidth: true };
    return <StyledFormLabel {...props} variant={contentContext.fullWidth ? "body2" : "body2Highlight"} />;
}

export default SmartFormLabel;
